import { Navigate, Outlet } from 'react-router-dom';
import { useCareAuth } from '../../context/CareAuthContext';
import { isAccountantOnly } from '../../lib/chutexAuth';

export default function CareProtectedRoute() {
  const { isAuthenticated, loading } = useCareAuth();
  if (isAccountantOnly()) {
    return <Navigate to="/compta" replace />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-zinc-900">
        <p className="text-sm text-zinc-500">Vérification de la session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
